// src/modules/components/reports/calls/ExportProgressDialog.js
import React from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  Typography,
  LinearProgress,
} from "@mui/material";

const ExportProgressDialog = ({ open, page, totalPages }) => {
  const progress = totalPages > 0 ? (page / totalPages) * 100 : 0;

  return (
    <Dialog open={open}>
      <DialogTitle>Export in Progress</DialogTitle>
      <DialogContent>
        <Typography>{`Exporting page ${page} / ${totalPages}`}</Typography>
        <LinearProgress variant="determinate" value={progress} />
      </DialogContent>
    </Dialog>
  );
};

export default ExportProgressDialog;